if (import.meta.env.NODE_ENV !== 'production') {
  window.ga = function (action, arg1, arg2) {
    console.debug(`GA:${action}::${arg1}::${arg2}`);
  };
}
